import NoOfStoresByFacingsChart from "./NoOfStoresByFacingsChart";
export default NoOfStoresByFacingsChart;
